import { render, staticRenderFns } from "./LegalContact.vue?vue&type=template&id=a1bbf284"
import script from "./LegalContact.vue?vue&type=script&lang=js"
export * from "./LegalContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports